import React from 'react';
import { getMessage } from '@tcc/i18n';
import ConfirmationModal from '../../../../../containers/Modal/ConfirmationModal';
import styles from '../../RegionReport.css';

export type CloseConfirmationViewProps = {
  onCancelConfirm: () => void;
  onCancelGoBack: () => void;
};

export const CloseConfirmationView = ({
  onCancelConfirm,
  onCancelGoBack,
}: CloseConfirmationViewProps) => (
  <div
    className={styles.confirmationModalContainer}
    data-test-id='dmb-region-report-close-confirmation-modal'
  >
    <ConfirmationModal
      confirmButtonText={getMessage('regions.report.modal.close')}
      handleClickConfirm={onCancelConfirm}
      handleClickGoBack={onCancelGoBack}
      handleClickCancel={onCancelConfirm}
      title={getMessage('regions.report.modal.confirm.close')}
      subTitle={getMessage('regions.report.modal.confirm.close.subheading')}
    />
  </div>
);
